function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2636 12.4479L18.7611 14.2438L14.6293 11.1735L13.4273 12.0945C12.9072 12.4931 12.2745 12.7085 11.6243 12.7085C10.9742 12.7085 10.3415 12.4931 9.82137 12.0945L9.31234 11.7045C9.22623 11.6385 9.15501 11.5544 9.10349 11.4578C9.05197 11.3613 9.02136 11.2546 9.01373 11.1449C9.0061 11.0352 9.02163 10.9251 9.05927 10.8221C9.0969 10.7191 9.15577 10.6255 9.23187 10.5478L12.9068 6.79328C12.9765 6.72201 13.0594 6.66547 13.1505 6.6269C13.2417 6.58833 13.3393 6.56848 13.438 6.56848L17.2586 6.56859",
  stroke: "#908E8E",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4976 19.9999L7.66732 19.277C7.55247 19.2477 7.44604 19.191 7.35669 19.1117L5.23889 17.231",
  stroke: "#908E8E",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.73633 12.3447L8.86926 16.4457C8.95215 16.5119 9.04773 16.5596 9.14981 16.5857L14.5922 17.9758C14.7181 18.0079 14.85 18.0062 14.975 17.9708C15.1 17.9354 15.2139 17.8676 15.3057 17.7739L18.7611 14.2436",
  stroke: "#908E8E",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.79529 6.46605L11.6145 5.03067C11.7866 4.9794 11.9711 4.99273 12.1344 5.06825L15.3806 6.56888",
  stroke: "#908E8E",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5847 11.2624L20.2636 12.4481L17.2587 6.56882L19.6034 5.37107C19.7796 5.28108 19.9833 5.26537 20.1707 5.32732C20.358 5.38927 20.5141 5.52392 20.6053 5.70229L22.9147 10.2207C22.9609 10.311 22.989 10.4099 22.9973 10.5114C23.0057 10.613 22.9942 10.7153 22.9635 10.8122C22.9328 10.9092 22.8835 10.999 22.8185 11.0762C22.7534 11.1535 22.674 11.2168 22.5847 11.2624Z",
  stroke: "#908E8E",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.73638 12.3451L2.57583 11.7522L1.41527 11.1594C1.32604 11.1138 1.24659 11.0505 1.18155 10.9732C1.11652 10.8959 1.06721 10.8062 1.03649 10.7092C1.00577 10.6122 0.994273 10.51 1.00266 10.4084C1.01104 10.3068 1.03914 10.208 1.08532 10.1177L3.39472 5.59927C3.48588 5.4209 3.64196 5.28624 3.82935 5.22429C4.01673 5.16234 4.22044 5.17805 4.3966 5.26804L6.74134 6.46579L3.73638 12.3451Z",
  stroke: "#908E8E",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/groupIcon.2987bc74.svg";
export { ForwardRef as ReactComponent };